import { ALL_LOCALES, DEFAULT_LOCALE } from './i18n.constants.js';

({
    i18n: {
        locales: process.env.NEXT_PUBLIC_ENABLE_I18N === 'true' ? ALL_LOCALES : [
            DEFAULT_LOCALE
        ]},
    reloadOnPrerender: process.env.NODE_ENV === 'development',
    debug: process.env.NODE_ENV === 'development'
});
//# sourceMappingURL=i18n.config.js.map
